import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Whirlpool4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WHIRLPOOL4;
}

export default Whirlpool4PoiTileEntity;
